import {API_URL, TERMS_OF_USE} from 'config/Api/urls';
import {errorStatusFilter, jsonFilter} from '../Filters';
import ApiBase from '../ApiBase'

class TermsOfUse extends ApiBase{

    constructor(){
        super()
        this.url = API_URL + TERMS_OF_USE;
    }

    async get(){
        let params = {
            method: 'GET',
            headers: this.headers(),
        }
        try{
            return await fetch(this.url, params).then(errorStatusFilter).then(jsonFilter)
        }catch(error){
            return {success: false, error: error}
        }
    }
    
    async update(data){
        let params = {
            method: 'POST',
            headers: this.headers(),
            body: JSON.stringify({ terms_of_use: data})
        }
        let url = this.url
        try {
            return await fetch(url, params).then(errorStatusFilter).then(jsonFilter);
        }catch(error){
            return {success: false, error: "erro"}
        }
    }

}

export default TermsOfUse;